import { useCallback } from "react";
import { useDispatch } from "react-redux"
import { sendFile, sendMessage } from "store/messages/messages.actions";
import useMessageInput from "views/SendMessage/useMessageInput";

const useSendMessage = () => {
    const [text] = useMessageInput();
    const dispatch = useDispatch();

    return useCallback((msg?: string, displayAs?: string, files?: File[], contentType?: connect.ChatMessageContentType) => {
        const message = msg || text
        if (!!message) {
            dispatch(sendMessage(message, displayAs, contentType))
        }
        files?.forEach(x => dispatch(sendFile({
            file: x,
            fileName: x.name,
        })))
    }, [dispatch, text])
}

export default useSendMessage;